import { Component } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { FormlyFieldConfig, FormlyModule } from '@ngx-formly/core';
import { ConfigService } from '../../shared/services/config.service';
import { FormlyWrapperFieldsetComponent } from '../../shared/formly-wrapper-fieldset/formly-wrapper-fieldset.component';
import { ToastrService } from 'ngx-toastr';
import { ConfigManagementService } from '../../shared/services/config-management.service';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-delivery-estimate-config',
    templateUrl: './delivery-estimate-config.component.html',
    standalone: true,
    imports: [ReactiveFormsModule, FormlyModule, MatButton]
})
export class DeliveryEstimateConfigComponent {
  form = new FormGroup({});
  model = { email: 'email@gmail.com' };
  fields: FormlyFieldConfig[] = [
    {
      key: 'method',
      type: 'select',
      name: 'Method',
      defaultValue: 'duration',
      props: {
        label: 'Calculation Method',
        options: [
          {
            label: 'Duration - Time in minutes to destination',
            value: 'duration'
          },
          {
            label: 'Distance - Distance in metres to destination',
            value: 'distance'
          }
        ]
      }
    },
    {
      key: 'sm',
      wrappers: [FormlyWrapperFieldsetComponent],
      props: { label: 'Small Vehicle' },
      fieldGroup: [
        {
          key: 'factor',
          type: 'input',
          props: {
            label: 'Factor',
            type: 'number',
            placeholder: 'Enter factor',
            required: true
          }
        },
        {
          key: 'minimum',
          type: 'input',
          props: {
            label: 'Minimum Charge',
            type: 'number',
            placeholder: 'Enter minimum',
            required: true
          }
        }
      ]
    },
    {
      key: 'md',
      wrappers: [FormlyWrapperFieldsetComponent],
      props: { label: 'Medium Vehicle' },
      fieldGroup: [
        {
          key: 'factor',
          type: 'input',
          props: {
            label: 'Factor',
            type: 'number',
            placeholder: 'Enter factor',
            required: true
          }
        },
        {
          key: 'minimum',
          type: 'input',
          props: {
            label: 'Minimum Charge',
            placeholder: 'Enter minimum',
            type: 'number',
            required: true
          }
        }
      ]
    },
    {
      key: 'lg',
      wrappers: [FormlyWrapperFieldsetComponent],
      props: { label: 'Large Vehicle' },
      fieldGroup: [
        {
          key: 'factor',
          type: 'input',
          props: {
            label: 'Factor',
            placeholder: 'Enter factor',
            type: 'number',
            required: true
          }
        },
        {
          key: 'minimum',
          type: 'input',
          props: {
            label: 'Minimum Charge',
            placeholder: 'Enter minimum',
            type: 'number',
            required: true
          }
        }
      ]
    },
    {
      key: 'rounding',
      wrappers: [FormlyWrapperFieldsetComponent],
      props: { label: 'Rounding' },
      fieldGroup: [
        {
          key: 'nearest',
          type: 'input',
          props: {
            label: 'Nearest',
            placeholder: 'Enter nearest',
            required: true,
            type: 'number'
          }
        },
        {
          key: 'alwaysRoundUp',
          type: 'checkbox',
          props: {
            label: 'Always Round Up',
            checked: 'false',
            value: '0'
          }
        }
      ]
    }
  ];

  constructor(
    private configService: ConfigService,
    private configManagementService: ConfigManagementService,
    private toastr: ToastrService
  ) {
    this.configService.userConfig.subscribe((config) => {
      this.model = config?.delivery_estimate_factors ?? {};
    });
  }

  onSubmit(model) {
    const config = {
      name: 'delivery_estimate_factors',
      value: JSON.stringify(model),
      set: null,
      id: null,
      sequence: 0
    };
    this.configManagementService.saveConfig(config).subscribe((response) => {
      this.toastr.success('Delivery Estimate Configuration Saved');
    });
  }
}
